import { Card, CardContent, CardHeader } from '@material-ui/core';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Cell,
} from 'recharts';
import { Finding } from '../utils/types';
import { EmptyChart } from './EmptyChart';

interface StatusBarChartProps {
  findings: Finding[];
}

const STATUS_COLORS: Record<string, string> = {
  Active: '#d32f2f',
  Verified: '#388e3c',
  'False Positive': '#9e9e9e',
  Mitigated: '#1976d2',
  'Out of Scope': '#757575',
  'Risk Accepted': '#f57c00',
};

export const StatusBarChart = ({ findings }: StatusBarChartProps) => {
  const groups: Record<string, number> = {};
  for (const f of findings) {
    groups[f.status] = (groups[f.status] || 0) + 1;
  }

  const data = Object.entries(groups).map(([status, count]) => ({
    status,
    count,
  }));

  if (data.length === 0) {
    return <EmptyChart title="Findings por Status" />;
  }

  return (
    <Card>
      <CardHeader title="Findings por Status" />
      <CardContent>
        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="status" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Bar dataKey="count" maxBarSize={60} radius={[4, 4, 0, 0]}>
              {data.map(entry => (
                <Cell
                  key={entry.status}
                  fill={STATUS_COLORS[entry.status] ?? '#9e9e9e'}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
